/** @module builtins/Date */

/* eslint-disable no-extend-native */

/**
 * Override the default toString method of the Date object to remove the trailing microseconds and 'Z'.
 * The representation returned will always be in the +0200 timezone.
 * @returns {String} The string representation of the Date object.
 */
Object.defineProperty(Date.prototype, 'toString', {
    value: function () {
        if (!this.valueOf()) {
            return null;
        }
        const ret = new Date(this.getTime() + -this.getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];
        return this.dateonly ? ret.split('T')[0] : ret;
    },
});

/**
 * Overrides the default toJSON method of the Date object to be similar to toString.
 * @returns {String}
 */
Object.defineProperty(Date.prototype, 'toJSON', {
    value: function () {
        return this.toString();
    },
});

/**
 * Return a timestamp similar to moment().asTimestamp(), but faster.
 * @returns {String}
 */
Object.defineProperty(Date.prototype, 'asTimestamp', {
    value: function () {
        return this.toString().replace('T', ' ') + '.' + this.getMilliseconds();
    },
});

/* eslint-enable no-extend-native */
